import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { 
  Navigation, 
  HeroSection, 
  AboutSection, 
  ServicesSection, 
  TestimonialsSection, 
  LivingInHarmonySection,
  FAQSection,
  ContactSection, 
  Footer 
} from './components';
import CookieBanner from './CookieBanner';
import PrivacyPolicyPage from './PrivacyPolicyPage';
import TermsOfServicePage from './TermsOfServicePage';

// Main homepage component
const HomePage = () => {
  return (
    <>
      <Navigation />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <TestimonialsSection />
      <LivingInHarmonySection />
      <FAQSection />
      <ContactSection />
      <Footer />
      <CookieBanner />
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;